import {
  AtlasBodySubtitle,
  ConfirmationDialogMolecule,
  TextBoxMolecule
} from '@justomx/atlas-components'
import { useState, type MutableRefObject } from 'react'

import { StackAtom } from 'components/atoms/Stack.atom'

interface OptionsDialogProps {
  dialogRef: MutableRefObject<HTMLDialogElement | null>
  title: string
  textboxLabel: string
  confirmLabel: string
  cancelLabel: string
  confirmAction: (value: string) => void
}

export const InputDialogOrganism = (props: OptionsDialogProps) => {
  const {
    dialogRef,
    title,
    textboxLabel,
    confirmLabel,
    cancelLabel,
    confirmAction
  } = props
  const [value, setValue] = useState('')

  const _onConfirm = () => {
    confirmAction(value)
    setValue('')
  }

  return (
    <ConfirmationDialogMolecule
      dialogRef={dialogRef}
      confirmText={confirmLabel}
      onConfirm={() => {
        _onConfirm()
      }}
      onCancel={() => {
        setValue('')
      }}
      cancelText={cancelLabel}
      confirmDisabled={!value}
    >
      <AtlasBodySubtitle>{title}</AtlasBodySubtitle>

      <StackAtom $padding="24px 0 0 0">
        <TextBoxMolecule
          label={textboxLabel}
          onChange={setValue}
          value={value}
        />
      </StackAtom>
    </ConfirmationDialogMolecule>
  )
}
